import { has } from 'lodash';
import * as types from './types';

const INITIAL_STATE = {
  fetching: false,
  fetchError: null,
  config: null,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.DASHBOARD_FETCHING:
      return {
        ...state,
        fetching: payload,
        config: payload ? null : state.config,
      };

    case types.DASHBOARD_FETCH_CONFIG:
      return {
        ...state,
        config: payload,
      };

    case types.DASHBOARD_FETCH_ERROR:
      if (has(payload, 'response.data.Errors')) {
        const fetchError = payload.response.data.Errors[0];

        return {
          ...state,
          fetchError,
        };
      }

      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message:
            'An error occurred while retrieving Dashboard configuration. Please reload the page to try again.',
        },
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/home/state/dashboard/reducer.js